import {InterfaceState, Interface, MostRecentExecutionRecord} from "./types";
import {ActionTree, Module, MutationTree, GetterTree} from "vuex";
import {RootState} from "@/store/types";
import {
    getInterfaces,
    getInterface,
    executeProcurementInterface,
    getExecutionRecords,
    executeVendorInterface,
    executeCustomerInterface,
    executeItemsInterface,
    executeNetCostInterface,
    executeBOMInterface,
    executeSaleInterface,
    executeExchangeRate,
    executeCustomerModel,
    scheduleInterface,
} from "@/services/interface";

export const state: InterfaceState = {
    interface: {
        name: "",
        url: ""
    },
    selected_interface: {
        name: "",
        url: ""
    },
    execution_date: {
        date: ""
    },
    most_recent_execution_record: {
        createdAt: '',
        description: [],
        id: 0,
        id_interface: 0,
        status: '',
        executedAt: "",
    },
    executed_interface: false,
}

const actions: ActionTree<InterfaceState, RootState> = {
    async GET_INTERFACES() {
      return await getInterfaces();
    },
    async GET_INTERFACE(_, id) {
        return await getInterface(id);
    },
    async EXECUTE_PROCUREMENT_INTERFACE(_, fmtPeriod) {
        await executeProcurementInterface(fmtPeriod);
    },
    async GET_EXECUTION_RECORDS(_, payload) {
        return await getExecutionRecords(payload);
    },
    async EXECUTE_VENDOR_INTERFACE(_, fmtPeriod) {
        await executeVendorInterface(fmtPeriod);
    },
    async EXECUTE_CUSTOMER_INTERFACE(_, fmtPeriod) {
        await executeCustomerInterface(fmtPeriod);
    },
    async EXECUTE_ITEMS_INTERFACE(_, fmtPeriod) {
        await executeItemsInterface(fmtPeriod);
    },
    async EXECUTE_NET_COST_INTERFACE(_, fmtPeriod) {
        await executeNetCostInterface(fmtPeriod);
    },
    async EXECUTE_BOM_INTERFACE(_, fmtPeriod) {
        await executeBOMInterface(fmtPeriod);
    },
    async EXECUTE_SALE_INTERFACES(_, fmtPeriod) {
        await executeSaleInterface(fmtPeriod);
    },
    async EXECUTE_EXCHANGE_RATE(_, fmtPeriod) {
        await executeExchangeRate(fmtPeriod);
    },
    async EXECUTE_CUSTOMER_MODEL(_, fmtPeriod) {
        await executeCustomerModel(fmtPeriod);
    },
    async SCHEDULE_INTERFACE(_, payload) {
        await scheduleInterface(payload);
    }
}

const mutations: MutationTree<InterfaceState> = {
    SET_SELECTED_INTERFACE(state, selected_interface: Interface) {
        state.selected_interface = selected_interface;
    },
    SET_EXECUTION_DATE(state, selectedDate: string) {
        state.execution_date.date = selectedDate;
    },
    SET_MOST_RECENT_EXECUTION_RECORD(state, mostRecentRecord: MostRecentExecutionRecord) {
        state.most_recent_execution_record = mostRecentRecord
    },
    RESET_MOST_RECENT_EXECUTION_RECORD(state) {
        state.most_recent_execution_record = {
            createdAt: '',
            description: [],
            id: 0,
            id_interface: 0,
            status: '',
            executedAt: ""
        }
    },
    SET_EXECUTED_INTERFACE(state, executedInterface: boolean) {
        state.executed_interface = executedInterface;
    }
}

const getters: GetterTree<InterfaceState, RootState> = {
    SELECTED_INTERFACE(state): Interface | undefined {
      return state.selected_interface;
    },
    EXECUTION_DATE(state): string | undefined {
        return state.execution_date.date;
    },
    MOST_RECENT_EXECUTION_RECORD(state): MostRecentExecutionRecord | undefined {
        return state.most_recent_execution_record;
    },
    EXECUTED_INTERFACE(state): boolean {
        return state.executed_interface;
    }
}

export const erp_interface: Module<InterfaceState, RootState> = {
    state,
    actions,
    getters,
    mutations
  }

